<template>
  <div>
    <v-dialog v-model="newTicket.dialog" persistent max-width="900">
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">Send request by technician</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout row wrap>
                <div
                  style="display: contents;"
                  v-if="!newTicket.isRequesterSelected"
                >
                  <v-flex xs12 sm5 v-if="!newTicket.isCustomName">
                    <manage-engine-user-autocomplete
                      :active="manageEngineUserAutocomplete"
                      @selectedUser="newTicket.requester = $event"
                    />
                  </v-flex>
                  <v-flex xs12 sm5 v-if="newTicket.isCustomName">
                    <v-text-field
                      v-model="newTicket.customName"
                      label="Enter Custom Name"
                      ref="newTicketCustomName"
                      :rules="newTicket.isCustomName ? [rules.required] : []"
                    ></v-text-field>
                  </v-flex>
                  <v-flex shrink class="px-2">
                    <v-checkbox
                      v-model="newTicket.isCustomName"
                      label="CN"
                      ref="newTicketIsCustomName"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </div>
                <div style="display: contents;" v-else>
                  <v-flex xs12 sm5>
                    <v-text-field
                      label="Name"
                      ref="newTicketName"
                      :rules="[rules.required]"
                      disabled
                      :value="newTicket.requester.name"
                    ></v-text-field>
                  </v-flex>
                </div>
                <v-flex xs12 sm3>
                  <v-select
                    v-model="newTicket.priority"
                    :items="['High', 'Normal', 'Low']"
                    label="Priority"
                    ref="newTicketSelectedPriority"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    v-model="newTicket.category"
                    placeholder="Start typing..."
                    :items="[...categorys]"
                    label="Category"
                    :rules="[rules.required]"
                    ref="newTicketCategory"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-flex xs12 sm8>
                <v-text-field
                  v-model="newTicket.subject"
                  label="Enter a brief title for your request"
                  ref="newTicketSubject"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-Textarea
                  rows="2"
                  v-model="newTicket.description"
                  label="Write a message"
                  outline
                  ref="newTicketDescription"
                ></v-Textarea>
              </v-flex>
              <v-layout row>
                <v-icon>mdi-phone</v-icon>
                <v-flex xs12 sm5>
                  <v-text-field v-model="newTicket.phone" label="Phone Number">
                  </v-text-field>
                </v-flex>

                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="newTicket.ext"
                    label="Ext Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="newTicket.room"
                    label="Room Number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-card
                    outlined
                    class="red-frame pa-3 mb-3"
                    style="border: 2px solid red;"
                  >
                    <v-card-title class="red--text text--darken-2 py-2">
                      <strong>For Office Use Only </strong>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row>
                        <v-flex xs12 sm12>
                          <v-Textarea
                            rows="1"
                            v-model="newTicket.internalNote"
                            label="Internal Note"
                            ref="newTicketInternalNote"
                          ></v-Textarea>
                        </v-flex>
                        <v-flex xs12 sm7 class="pl-4">
                          <label for="dueDateValue">Choose a Due date:</label>
                          <input
                            :disabled="newTicket.dueDateValueNow"
                            type="date"
                            id="dueDateValue"
                            v-model="newTicket.dueDateValue"
                            style="padding: 8px; border: 1px solid #ccc; border-radius: 4px; width: 100%;"
                            :style="
                              newTicket.dueDateValueNow
                                ? 'background-color: #f5f5f5; cursor: not-allowed;'
                                : ''
                            "
                          />
                        </v-flex>
                        <v-flex xs12 sm6 class="pr-4">
                          <v-checkbox
                            v-model="newTicket.dueDateValueNow"
                            @change="newTicket.dueDateValue = null"
                            label="Due Now"
                            ref="dueDateValueNow"
                            color="primary"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs12 sm4>
                          <v-radio-group
                            label="Select Days Schedule"
                            v-model="newTicket.scheduleDaysType"
                          >
                            <v-radio
                              label="Regular days (Mon - Thu)"
                              value="reg-days"
                              color="primary"
                            ></v-radio>
                            <v-radio
                              label="Custom days"
                              value="custom-days"
                              color="primary"
                            ></v-radio>
                          </v-radio-group>
                          <div
                            v-if="newTicket.scheduleDaysType === 'custom-days'"
                            class="d-flex align-center mt-0"
                          >
                            <v-select
                              v-model="newTicket.scheduleCustomSelectedDays"
                              :items="[
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                              ]"
                              label="Select Days"
                              multiple
                              chips
                              closable-chips
                              :rules="[
                                (v) =>
                                  v.length > 0 ||
                                  'At least one day is required',
                              ]"
                              style="max-width: 190px;"
                            ></v-select>
                          </div>

                          <input type="hidden" :value="newTicket.schedule" />
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-radio-group
                            label="Select a Time Schedule"
                            v-model="newTicket.scheduleTimeType"
                          >
                            <v-radio
                              color="primary"
                              label="Reg hours 9:30 AM - 5:00 PM"
                              value="reg-hours"
                            ></v-radio>
                            <v-radio
                              color="primary"
                              label="Custom hours"
                              value="custom-hours"
                            ></v-radio>
                          </v-radio-group>
                          <div
                            v-if="newTicket.scheduleTimeType === 'custom-hours'"
                            class="d-flex align-center mt-0"
                          >
                            <v-text-field
                              v-model="newTicket.scheduleStartTime"
                              :rules="[rules.required]"
                              label="From"
                              type="time"
                              class="mr-4"
                              style="max-width: 160px;"
                            ></v-text-field>

                            <span class="mx-2">to</span>

                            <v-text-field
                              v-model="newTicket.scheduleEndTime"
                              :rules="[rules.required]"
                              label="To"
                              type="time"
                              style="max-width: 160px;"
                            ></v-text-field>
                          </div>

                          <input type="hidden" :value="newTicket.schedule" />
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-checkbox
                            v-model="newTicket.affectedMany"
                            label="Affected many"
                            ref="newTicketAffect"
                            color="primary"
                          ></v-checkbox>
                          <v-checkbox
                            v-model="newTicket.specialEntry"
                            label="Special Entry Info"
                            ref="newTicketSpecialEntry"
                            color="primary"
                          ></v-checkbox>
                          <v-text-field
                            v-if="newTicket.specialEntry"
                            v-model="newTicket.specialEntryInfo"
                            label="Enter the info"
                            ref="newTicketSpecialEntryInfo"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-flex xs12 sm8> </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3 pt-0">
            <v-spacer></v-spacer>

            <v-btn
              :loading="processing"
              color="default"
              @click="closeDialog"
              :dark="true"
              :disabled="false"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              dark
              color="success"
              @click="saveNewTicket"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ManageEngineUserAutocomplete from "./ManageEngineUserAutocomplete.vue";
export default {
  components: {
    ManageEngineUserAutocomplete,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    rules: {
      required: (value) => !!value || "Required.",
    },
    newTicket: {
      dialog: Boolean,
      subject: "",
      description: "",
      category: "",
      priority: "Normal",
      phone: "",
      room: "",
      ext: "",
      requester: null,

      affectedMany: false,

      scheduleDaysType: "reg-days",
      scheduleCustomSelectedDays: [],

      scheduleTimeType: "reg-hours",
      scheduleStartTime: "",
      scheduleEndTime: "",

      specialEntry: false,
      specialEntryInfo: "",

      urgency: "",
      dueDateValue: null,
      dueDateValueNow: false,

      internalNote: "",

      isCustomName: false,
      customName: "",

      isRequesterSelected: false,
    },
    manageEngineUserAutocomplete: false,

    mappedExtensions: [],
    mappedPhones: [],
    processing: false,
    categorys: [],
  }),
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val == true) {
          this.getCategorys();
          this.manageEngineUserAutocomplete = true;
        }

        if (this.initialData.requester) {
          this.newTicket.requester = this.initialData.requester;
          this.newTicket.isRequesterSelected = true;
        }
        this.newTicket.dialog = val;
      },
    },
    "newTicket.dialog"(val) {
      this.$emit("input", val);
      if (!val) {
        this.resetForm();
      }
    },
  },

  methods: {
    async saveNewTicket() {
      var customDueDate =
        new Date(this.newTicket.dueDateValue).getTime() + 100800000;
      if (this.newTicket.dueDateValue && customDueDate < new Date().getTime()) {
        return this.$notify({
          text:
            "Set valid due by date. Due by date cannot be a prior date to created date.",
          group: "notification",
          type: "error",
        });
      }
      if (!this.$refs.form.validate(true)) {
        return;
      }
      try {
        this.processing = true;
        const hasUserInfo =
          this.newTicket.phone ||
          this.newTicket.room.trim() ||
          this.newTicket.ext.trim();

        const userInfo = [
          this.newTicket.phone
            ? `<b>Phone</b>: ${this.newTicket.phone}<br>`
            : "",
          this.newTicket.room.trim()
            ? `<b>Room</b>: ${this.newTicket.room.trim()}<br>`
            : "",
          this.newTicket.ext.trim()
            ? `<b>Ext</b>: ${this.newTicket.ext.trim()}`
            : "",
        ]
          .filter(Boolean)
          .join("");

        const desc = `${this.newTicket.description.trim()}${
          hasUserInfo ? `<br><br><br><br>${userInfo}` : ""
        }`;
        const description = desc
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");
        const priorityMap = {
          High: "3 Option 8",
          Normal: "2 Normal",
          Low: "4 Low",
        };

        var scheduleDays = null;
        var scheduleHours = null;

        if (this.newTicket.scheduleDaysType != "reg-days") {
          scheduleDays = this.newTicket.scheduleCustomSelectedDays;
        }

        if (this.newTicket.scheduleTimeType != "reg-hours") {
          scheduleHours = `${this.newTicket.scheduleStartTime} - ${
            this.newTicket.scheduleEndTime
          }`;
        }

        const techData = [
          this.newTicket.isCustomName
            ? `<b>Name</b>: ${this.newTicket.customName}<br><br>`
            : "",
          this.newTicket.affectedMany
            ? `<b>Affected Many</b>: "Yes"<br><br>`
            : "",
          scheduleDays
            ? `<b>Schedule Days</b>: ${JSON.stringify(scheduleDays)}<br><br>`
            : "",
          scheduleHours
            ? `<b>Schedule Hours</b>: ${scheduleHours}<br><br>`
            : "",
          this.newTicket.specialEntryInfo
            ? `<b>Special Entry Info</b>: ${
                this.newTicket.specialEntryInfo
              }<br><br>`
            : "",
          this.newTicket.internalNote
            ? `<b>Internal Note</b>: ${this.newTicket.internalNote}`
            : "",
        ]
          .filter(Boolean)
          .join("");

        const payload = {
          UserId: !this.newTicket.isCustomName
            ? this.newTicket.requester.id
            : "24078000030239745", // defaultuser@utaw.org
          Subject: this.newTicket.subject.trim(),
          Description: description,
          Priority: priorityMap[this.newTicket.priority],
          Category: this.newTicket.category
            ? this.newTicket.category
            : "Untitled",
          Urgency: this.newTicket.urgency,

          TechData: techData,
          ITReceptionBy: this.$store.state.authentication.user,
          DueDateValue: this.newTicket.dueDateValueNow
            ? new Date().getTime() + 60000
            : customDueDate,
        };
        const response = await this.$http.post(
          "api/Manageengine/ManageenginePost",
          payload
        );

        this.processing = false;
        this.$emit("newTicketSended");
        this.closeDialog();
       // this.$refs.grid.reloadGrid();

        this.$notify({
          text: "Ticket Sent successfully",
          group: "notification",
          type: "success",
        });
        this.newTicket.dialog = false;
        await this.$http.get(
          `api/manageengine/getRequestbyID?id=${response.request.display_id}`
        );

        // this.$router.push({
        //   name: "HelpDeskRequestView",
        //   params: { id: response.request.display_id },
        // });
      } catch (e) {
        this.processing = false;
        this.cancelBtnAbility = false;
        this.$notify({
          group: "notification",
          text: "Ticket could not be submitted.",
          type: "error",
        });
      }
    },

    closeDialog() {
      this.newTicket.dialog = false;
    },
    resetForm() {
      this.newTicket = {
        dialog: false,
        subject: "",
        description: "",
        category: "",
        priority: "Normal",
        phone: "",
        room: "",
        ext: "",
        requester: "",
        affectedMany: false,
        scheduleDaysType: "reg-days",
        scheduleCustomSelectedDays: [],
        scheduleTimeType: "reg-hours",
        scheduleStartTime: "",
        scheduleEndTime: "",
        specialEntry: false,
        specialEntryInfo: "",
        urgency: "",
        internalNote: "",
        isCustomName: false,
        customName: "",
        dueDateValue: null,
      };
      this.$refs.form.resetValidation(true);
      this.manageEngineUserAutocomplete = false;
    },

    async getCategorys() {
      try {
        const response = await this.$http.get("api/manageengine/getCategorys");
        this.categorys = response.category.map((m) => m.name);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
